var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"winning-hamster"},[(_vm.isGameInPlay)?_c('span',[_vm._v(_vm._s(_vm.$lang.game.hamsterRace.firstPlace))]):_c('span',{staticClass:"fa fa-trophy trophy-icon"}),_vm._v(" "),_c('img',{attrs:{"src":_vm.firstPlaceHamsterImageUrl}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77bad7a8","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/components/game/implementations/uk/hamster-race/_components/call-value/call-value.html
// module id = null
// module chunks = 